import React, { createContext, useState, useEffect } from 'react';

export const SessionStateContext = createContext();

export function SessionStateProvider({ children }) {
  const key = 'app-session';
  const getInitial = () => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  };

  const [state, setState] = useState(getInitial);

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(state));
  }, [state]);

  return (
    <SessionStateContext.Provider value={[state, setState]}>
      {children}
    </SessionStateContext.Provider>
  );
}
